/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZD0iTTExLjQxMjggMTMuNjI3OUgyLjg3MjA5VjUuMDg3MjFIOS40NjUxMlY0LjIxNTEySDJWMTQuNUgxMi4yODQ5VjcuMDM0ODlIMTEuNDEyOFYxMy42Mjc5WiIgZmlsbD0iaW5oZXJpdCIvPjxwYXRoIGQ9Ik03Ljc3OTA3IDJWMi44NzIwOUgxMi45OTQyTDYuMjczMjUgOS41OTMwMkw2Ljg4OTUzIDEwLjIwOTNMMTMuNjI3OSAzLjQ3MDkzVjguNzIwOTNIMTQuNVYySDcuNzc5MDdaIiBmaWxsPSJpbmhlcml0Ii8+";